import * as Sentry from "@sentry/browser";
import { createAsyncAction, errorResult, successResult } from "pullstate";
import { Address } from "viem";
import { ohlcSchema } from "../../generated-schemas-tokens";
import { GlobalStore } from "./GlobalStore";
import { Chain } from "viem/chains";
import { z } from "zod";
import { API_BASE_URL } from "../../config/env";
import { CHAINS } from "../../config/chains";

async function fetchChartData(tokenAddress: Address, chain: Chain) {
  try {
    const result = await fetch(
      `${API_BASE_URL}/tokens/v1/${CHAINS[chain.id].apiName}/${tokenAddress}/chart`
    );
    if (result.ok) {
      return result.json();
    } else {
      return errorResult([], `Could not get chart data`);
    }
  } catch (e) {
    Sentry.captureException(`Could not get chart data`, { extra: { event: e } });
    return errorResult([], `Could not get chart data`, e);
  }
}

const validateTokensChartResponse = (tokensChartResponse: unknown) => {
  const ohlcArraySchema = z.array(ohlcSchema);
  const result = ohlcArraySchema.safeParse(tokensChartResponse);
  return result;
};

export const getChartData = createAsyncAction(
  async ({ tokenAddress, chain }: { tokenAddress: Address; chain: Chain }) => {
    try {
      const result = await fetchChartData(tokenAddress, chain);

      if (result) {
        const isValidResponse = validateTokensChartResponse(result);
        if (isValidResponse.success) {
          return successResult(result);
        } else {
          console.error(`Invalid response from chart endpoint`);
          return errorResult([], `Invalid response from chart endpoint`);
        }
      }
    } catch (e) {
      console.log(e);
      Sentry.captureException(`Could not get chart data`, { extra: { event: e } });
      return errorResult([], `Could not get chart data`, e);
    }
    Sentry.captureException(`Could not get chart data`);
    return errorResult([], `Could not get chart data`);
  },
  {
    postActionHook: ({ result, args }) => {
      if (!result.error) {
        console.log(result.payload, "getChartData");
        GlobalStore.update(s => {
          s.chartLists = { ...s.chartLists, [args.tokenAddress]: result.payload };
        });
      } else {
        console.error(`Error fetching chart: ${result.error}`);
      }
    },
  }
);
